module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightsnowshowers@2-e9bc99a52525bab914bb8d1db4a58006.png";